import apiAdressesLad from "@/services/http/api-drive/client/adresseLad";
import { useClientStore } from "@/store/client";

export const pageMonCompteMesAdressesProps = () => ({
  client: {
    type: Object,
    required: true
  },
  isPro: {
    type: Boolean,
    required: false,
    default: false
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  },
  adressesLad: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  defaultAddress: {
    type: Object,
    required: false
  },
  otherAddresses: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  },
  adressesDetails: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  }
})

export const pageMonCompteMesAdressesEmits = () => ([
  "fetchAddresses"
])

export const usePageMonCompteMesAdresses = (props, context, supprimerRef, popinAddressDetailRef, modifierAdresseRef, ajouterRef) => {

  const app = useNuxtApp();
  const adressToDeleteId = ref(null);
  const adressDetailsId = ref(null);
  const addressToEditId = ref(null);
  const error = ref(null);

  const { update: clientUpdate } = useClientStore();

  const updateBillingAddress = (clientData) => {
    clientUpdate(clientData);
  }
  const deleteAddress = (id) => {
    supprimerRef.value.show()
    adressToDeleteId.value = id
  }
  const showAddressDetails = (id) => {
    popinAddressDetailRef.value.show()
    adressDetailsId.value = id
  }
  const addressDeleted = async () => {
    try {
      await app.$apiDrive.use(apiAdressesLad).delete(adressToDeleteId.value);
      addresseLadSaved()
    } catch (e) {
      error.value = e
    }
  }
  const setAddressDefault = async (id) => {
    try {
      if (props.defaultAddress) {
        await app.$apiDrive.use(apiAdressesLad).update(props.defaultAddress.id, { defaut: false });
      }
      await app.$apiDrive.use(apiAdressesLad).update(id, { defaut: true });
      addresseLadSaved()
    } catch (e) {
      error.value = e
    }
  }
  const editAddress = (id) => {
    addressToEditId.value = id;
    modifierAdresseRef.value.show();
  }
  const addresseLadSaved = () => {
    context.emit("fetchAddresses");
    modifierAdresseRef.value.hide();
    ajouterRef.value.hide()
  }
  const getAdressDetailsById = (id) => {
    return props.adressesDetails.find(address => address.id === id)
  }

  return {
    adressToDeleteId,
    adressDetailsId,
    addressToEditId,
    error,
    updateBillingAddress,
    deleteAddress,
    showAddressDetails,
    addressDeleted,
    setAddressDefault,
    editAddress,
    addresseLadSaved,
    getAdressDetailsById
  }
}